import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import authx from "./modules/products/authx";
import VuexPerist from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPerist({
  key: "radius-user",
  modules: ["auth", "authx"],
  storage: window.sessionStorage
});

const ifInProduction = process.env.NODE_ENV === "production";

const store = new Vuex.Store({
  modules: {
    auth,
    authx
  },
  plugins: [vuexLocal.plugin],
  strict: ifInProduction
});

export default store;
